import React, {memo, useEffect} from 'react'
import {startCase} from 'lodash'
import {Button, Header, Table} from 'semantic-ui-react'
import {UpdatePaymentMethod} from './update-payment-method'
import {RemovePaymentMethod} from './remove-payment-method'
import {useSafeState} from '../../hook'
import {withPropsPresent} from '../../hoc'
import SubscriptionSummary from './subscription-summary'

const _PaymentMethod = (
  {
    me,
    subscription,
    onSubscriptionUpdated
  }
) => {
  const [state, setState] = useSafeState({display: 'view', subscription})

  useEffect(() => {
    setState({...state, display: 'view', subscription})
  }, [subscription])

  const onUpdatePaymentMethod = (e) => {
    e.preventDefault()
    setState({...state, display: 'update'})
  }

  const onRemovePaymentMethod = (e) => {
    e.preventDefault()
    setState({...state, display: 'remove'})
  }

  const onClose = async (subscription) => {
    setState({...state, subscription, display: 'view'})
    onSubscriptionUpdated(subscription)
  }

  if (state.display === 'update') {
    return (<UpdatePaymentMethod {...{me, subscription: state.subscription, onClose}}/>)
  }

  if (state.display === 'remove') {
    return (<RemovePaymentMethod {...{subscription: state.subscription, onClose}}/>)
  }

  return (
    <>
      <Header as='h3'>Card</Header>
      {
        !state.subscription.paymentMethod && (
          <div data-testid='card-not-present'>No card found</div>
        )
      }
      {
        !!state.subscription.paymentMethod && (
          <Table celled columns='16' data-testid='card-details'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Type</Table.HeaderCell>
                <Table.HeaderCell>Last 4</Table.HeaderCell>
                <Table.HeaderCell>Expiration</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell width='1'
                            data-testid='card-type'>{startCase(state.subscription.paymentMethod.card.brand)}</Table.Cell>
                <Table.Cell width='2' data-testid='card-last-4'>**** ****
                  **** {state.subscription.paymentMethod.card.last4}</Table.Cell>
                <Table.Cell
                  data-testid='card-expiration'
                  width='1'>{state.subscription.paymentMethod.card.exp_month}/{state.subscription.paymentMethod.card.exp_year}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        )
      }
      <div style={{marginTop: '25px'}}>
        {
          !state.subscription.paymentMethod && (<Button basic primary
                                                        data-testid='card-upsert-button'
                                                        onClick={onUpdatePaymentMethod}>Add Card</Button>)
        }
        {
          (subscription.planName === 'free' && !!state.subscription.paymentMethod) && (
            <Button basic primary onClick={onRemovePaymentMethod} data-testid='card-remove-button'>Remove
              Card</Button>)
        }
      </div>
    </>
  )
}

let PaymentMethod = (props) => {
  return (<_PaymentMethod {...props}/>)
}

PaymentMethod = withPropsPresent(PaymentMethod, ['subscription'])
PaymentMethod = memo(PaymentMethod)

export {PaymentMethod, _PaymentMethod}

export default PaymentMethod